import styled from "styled-components";

export const TestimonialsCarouselMobileBox = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap:1rem;
`